export default __webpack_public_path__ + "fdf9d9f7fbb64f338ea4f0c633fb64e4.png";